import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { WindowNewRegular } from "@fluentui/react-icons";
import * as React from "react";
import { useNavigate } from "react-router-dom";

export const NewThreadButton: React.FC = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  return (
    <Button
      className={classes.title}
      appearance="transparent"
      size="large"
      icon={<WindowNewRegular />}
      onClick={() => {
        navigate("/");
      }}
    >
      新規チャット
    </Button>
  );
};

const useStyles = makeStyles({
  title: {
    display: "flex",
    justifyContent: "flex-start",
    margin: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS}`,
    borderRadius: tokens.borderRadiusMedium,
    textAlign: "left",
    textDecoration: "none",
    ":hover": {
      "background": tokens.colorNeutralBackground4Hover,
      "cursor": "pointer",
    },
  },
});
